const CHAT_BASE = "/chat";

export const chatEndpoints = {
  getUserConversations: () => `${CHAT_BASE}/conversations`,
  getUserUnreadCount: () => `${CHAT_BASE}/conversations/unread-count`,
  getConversation: (conversationId: string, pageParam?: number) =>
    `${CHAT_BASE}/conversations/${conversationId}/messages?page=${pageParam}`,
  deleteConversation: (conversationId: string) =>
    `${CHAT_BASE}/conversations/${conversationId}`,
  uploadImages: () => `${CHAT_BASE}/images`,
};

const CHAT_PUBLIC_BASE = "/chat-public";

export const chatPublicEndpoints = {
  createMessageGuestUser: `${CHAT_PUBLIC_BASE}/lead`,
  createMessageGoogleGuestUser: `${CHAT_PUBLIC_BASE}/google-lead`,
};
